import React, { FC } from 'react'
import { Box, Grid, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IDedicatedLanesModalItemProps {
  label: string
  text: React.ReactNode
  textSecondary?: string
  additionalInfo?: React.ReactNode
}

const useDedicatedLaneModalItemStyles = makeStyles(() => ({
  text: {
    color: brandColors.coolGray5,
  },
}))

export const DedicatedLanesModalItem: FC<IDedicatedLanesModalItemProps> = ({
  additionalInfo,
  label,
  text,
  textSecondary,
}) => {
  const classes = useDedicatedLaneModalItemStyles()
  return (
    <Box pb={0.5}>
      <Grid container>
        <Grid item sm={6} md={4}>
          <Typography className={classes.text} variant='body2'>
            {label}
          </Typography>
        </Grid>
        <Grid item sm={6} md={6}>
          <Box pt={0.5}>
            <Typography variant='subtitle2'>{text}</Typography>
            {textSecondary && <Typography variant='caption'>{textSecondary}</Typography>}
          </Box>
          {additionalInfo && <div>{additionalInfo}</div>}
        </Grid>
      </Grid>
    </Box>
  )
}
